import { FC, PropsWithChildren } from 'react';

import useImageType from '@hooks/useImageType';
import { useLocalStorage } from '@hooks/useLocalStorage';

import GlobalViewModeContext, { ContentViewMode, getOppositeViewMode } from './context';

export const GlobalViewModeProvider: FC<PropsWithChildren> = ({ children }) => {
  const { imageType, setImageType } = useImageType({
    defaultImageType: 'wide',
    localStorageKey: 'titleSearchImageViewMode',
  });

  const [contentViewMode, setContentViewMode] = useLocalStorage<ContentViewMode>(
    'searchViewMode',
    'grid'
  );

  const toggleViewMode = () => setContentViewMode(getOppositeViewMode(contentViewMode));

  return (
    <GlobalViewModeContext.Provider
      value={{
        imageType,
        setImageType,
        contentViewMode,
        toggleViewMode,
      }}
    >
      {children}
    </GlobalViewModeContext.Provider>
  );
};

export default GlobalViewModeProvider;
